import { useQuery } from "@tanstack/react-query";
import { apiRequest, getUserSession } from "utils/api";
import { getCompanyCurrency } from "utils/helpers";
import { CurrentUserType } from "providers/types";

export const CURRENT_USER_QUERY_KEY = ["current-user"];

export const getCurrentUserQuery = async (): Promise<CurrentUserType | null> => {
  const session = await getUserSession();

  if (!session) {
    return null;
  }

  const response = await apiRequest("/supabase/users/current");

  if (!response.user) {
    return null;
  }

  const user = {
    ...response.user,
    currency: getCompanyCurrency(response.user),
    metadata: {
      password_set: session?.user.user_metadata.password_set,
      onboarded: session?.user.user_metadata.onboarded,
    },
  };

  return user as CurrentUserType;
};

export const useCurrentUserQuery = () => {
  return useQuery({
    queryKey: CURRENT_USER_QUERY_KEY,
    queryFn: getCurrentUserQuery,
    staleTime: 1000 * 60 * 5, // 5 minutes
    gcTime: 1000 * 60 * 30, // 30 minutes
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};
